import { Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { useTrackPageView } from "../hooks/use-track-page-view";

export function RootComponent() {
  useTrackPageView();

  return (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  );
}
